module.exports = __webpack_public_path__ + "img/quickmenu_cn.b3f4632.jpg";